import { toDollars } from '@pelicargo/utils';

export const formatForClient = <T>(raw: T): T => {
  if (raw == null || typeof raw !== 'object') return raw;
  const next = { ...(raw as object) } as T;
  const o = next as Record<string, unknown>;
  if (o.cost != null) o.cost = toDollars(o.cost as number);
  if (o.per_unit_cost != null) o.per_unit_cost = toDollars(o.per_unit_cost as number);
  return next;
};

const convertToCents = (val: number) => Number((val * 100).toFixed(2));

export const formatForServer = <T>(raw: T): T => {
  const next = { ...(raw as object) } as T;
  const o = next as Record<string, unknown>;
  if (o.cost != null) o.cost = convertToCents(o.cost as number);
  if (o.per_unit_cost != null) o.per_unit_cost = convertToCents(o.per_unit_cost as number);
  return next;
};
